import { useState } from "react"
import { Head } from "@inertiajs/react"

import Navbar from "@/components/ttt/Navbar"
import Footer from "@/components/ttt/Footer"
import AuthorCard from "@/components/ttt/AuthorCard"
import type { TttChrome, TttAuthorSummary } from "@/components/ttt/types"

interface Props {
  chrome: TttChrome
  authors: TttAuthorSummary[]
  i18n: {
    title: string
    search_placeholder: string
    no_results: string
  }
}

export default function Authors({ chrome, authors, i18n }: Props) {
  const [query, setQuery] = useState("")

  const term = query.trim().toLowerCase()
  const filtered = term
    ? authors.filter((a) => a.nickname.toLowerCase().includes(term))
    : authors

  return (
    <>
      <Head>
        <title>{`${i18n.title} — TTT`}</title>
      </Head>

      <Navbar chrome={chrome} />

      <div className="max-w-5xl mx-auto flex flex-col items-center pt-36 px-6">
        <div className="w-full mb-12">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={i18n.search_placeholder}
            aria-label={i18n.search_placeholder}
            className="form-input border-primary w-full text-primary placeholder:text-primary"
          />
        </div>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-16 pb-24 w-full">
            {filtered.map((author) => (
              <AuthorCard key={author.id} author={author} />
            ))}
          </div>
        ) : (
          <p className="text-primary py-16">{i18n.no_results}</p>
        )}
      </div>

      <Footer chrome={chrome} />
    </>
  )
}
